import { sendMessage } from '~/public/lib/EmbedMessaging';

export function cleanContext(context) {
    // Remove spaces from all keys
    if (context === null) {
        return null;
    }
    context = Object.fromEntries(
        Object.entries(context).map(([key, value]) => {
            if (!Array.isArray(value) && typeof value === 'object') {
                value = cleanContext(value);
            } else if (Array.isArray(value)) {
                value = value.map(v => {
                    if (typeof v === 'object') {
                        return cleanContext(v);
                    }
                    return v;
                });
            }

            return [key.replace(/\s/g, '_').toLowerCase(), value];
        }),
    );

    return context;
}

export function conversionTrackSubmitted(context) {
    if (typeof fbq === 'function') {
        fbq('track', 'Schedule');
    }

    sendMessage('tracking', {
        eventName: 'breely_form_submitted',
        context: cleanContext(context),
    });
}

export function conversionTrackStep(name, context) {
    sendMessage('tracking', {
        eventName: 'breely_form_step' + name,
        context: cleanContext(context),
    });
}
